import { Box, Breadcrumb, Breadcrumbs } from '@pocketlaw/tetris';
import { useCompanyFeatures } from 'app/domains/companies';
import { ScreenLayout } from 'shared/domains/common-ui/ScreenLayout';
import { useAccount } from 'shared/domains/users';
import { CustomerDetail } from './CustomerDetail';
export function CustomerSuccess() {
    const { data } = useAccount();
    const { name, id, marketCode } = data.company;
    const { features } = useCompanyFeatures();
    const featureLabels = features.map((feature) => feature.toLocaleLowerCase()).sort();
    return (<ScreenLayout.Root id="customer-success" topbar={<ScreenLayout.Topbar breadcrumbs={<Breadcrumbs>
              <Breadcrumb>Customer success</Breadcrumb>
            </Breadcrumbs>}/>} content={<ScreenLayout.Content>
          <Box flexDirection="column" gap="2xl">
            <CustomerDetail title="Company name" value={name}/>
            <CustomerDetail title="Company id" value={id}/>
            <CustomerDetail title="Company market" value={marketCode}/>
            <CustomerDetail title="Company features" chips={featureLabels}/>
          </Box>
        </ScreenLayout.Content>}/>);
}
